module.exports = __webpack_public_path__ + "media/images/kids5-3d5d90642c2f985cd507582c88d8c309.jpg";